if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5;
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;

      /*
       * IMPORTANT :
       * On compte uniquement les vrais slides.
       * Cela permet d'éviter que Swiper crée des copies
       * lorsque le slideshow contient un seul slide.
       */
      this.slidesCount = this.querySelectorAll(
        ".swiper-wrapper > .swiper-slide"
      ).length;

      /*
       * Un seul slide :
       * - pas de loop
       * - pas d'autoplay
       * - pas de flèches
       * - pas de pagination
       */
      if (this.slidesCount <= 1) {
        this.autoplay = false;
        this.showArrows = false;
        this.showDots = false;
      }

      this.initSlider();
    }

    initSlider() {
      if (!this.sliderContainer) {
        return;
      }

      /*
       * Loop uniquement lorsqu'il y a plusieurs slides.
       */
      const enableLoop = this.slidesCount > 1;

      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,

        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,

        slidesPerView: 1,
        slidesPerGroup: 1,

        /*
         * IMPORTANT :
         * Avec un seul slide, loop = false.
         */
        loop: enableLoop,

        effect: "fade",

        fadeEffect: {
          crossFade: true,
        },

        speed: 1000,

        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(
                ".m-slider-controls__button-next"
              ),
              prevEl: this.querySelector(
                ".m-slider-controls__button-prev"
              ),
            }
          : false,

        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,

        breakpoints: {
          992: {
            threshold: 2,
          },
        },

        on: {
          init: () => {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      this.lastSlide = null;
      this.currentSlide = null;

      if (this.slider) {
        this.slider.on(
          "init",
          this.handleChange.bind(this)
        );

        this.slider.on(
          "slideChange",
          this.handleChange.bind(this)
        );
      }

      this.slider.init();

      /*
       * Shopify Theme Editor
       */
      if (Shopify.designMode) {
        document.addEventListener(
          "shopify:block:select",
          (e) => this.onBlockSelect(e)
        );
      }
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;

      const slideType =
        slides[activeIndex] &&
        slides[activeIndex].dataset.slideType;

      /*
       * Ne pas utiliser slideToLoop() lorsqu'il n'y a
       * qu'un seul slide.
       */
      if (
        this.slidesCount > 1 &&
        this.lastActive !== null &&
        this.lastActive !== undefined
      ) {
        /*
         * Évite de rappeler continuellement le même slide.
         */
        if (activeIndex !== this.lastActive) {
          this.slider.slideToLoop(this.lastActive);
        }
      }

      /*
       * Gestion vidéo
       */
      if (slideType === "video_slide") {
        const video =
          slides[activeIndex] &&
          slides[activeIndex].querySelector("video");

        if (video) {
          const playPromise = video.play();

          if (this.lastVideo) {
            this.lastVideo.pause();
          }

          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                this.lastVideo = video;
              })
              .catch(() => {
                this.lastVideo = null;
              });
          }
        }
      } else {
        if (this.lastVideo) {
          this.lastVideo.pause();
        }

        this.lastVideo = null;
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;

      if (!block) {
        return;
      }

      const index = Number(block.dataset.slide);

      this.lastActive = index;

      if (this.slider) {
        /*
         * Un seul slide : pas besoin de slideToLoop().
         */
        if (this.slidesCount > 1) {
          this.slider.slideToLoop(index);
        } else {
          this.slider.slideTo(index);
        }
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}